<template>
  <div class="d-flex justify-content-center align-items-center mt-4 mx-auto position-absolute" style="z-index: 99999;">
    <ModalRoot ref="modal">
      <GallerySections
      :images="pictures"
      :prestations="prestations"
      @close="closeModal"
      />
    </ModalRoot>
  </div>
</template>

<script>
import ModalRoot from "./ModalRoot.vue";
import GallerySections from "./GallerySections.vue"

export default {
  components: {
    ModalRoot,
    GallerySections,
  },
  props: {
    pictures: Array,
    prestations: Array,
  },
  data() {
    return {};
  },

  beforeDestroy() {
    window.removeEventListener('openResidenceGallery', this.$refs.modal.openModal);
  },

  methods: {
    getImageUrl(image) {
      return image.imgXL || image.imgLarge || image.img;
    },

    closeModal() {
      this.$refs.modal.closeModal()
    },
  },
  mounted() {
    window.addEventListener('openResidenceGallery', this.$refs.modal.openModal);
  }
};
</script>

<style scoped>
</style>